var render = function render(){var _vm=this,_c=_vm._self._c;return _c('q-page',{attrs:{"padding":""}},[_c('h1',[_vm._v("Welcome to the ICP Industry Account Page")])])
}
var staticRenderFns = []

export { render, staticRenderFns }